import { graphql } from '@/gql'

export const GetJobCandidatesQuery = graphql(/* GraphQL */ `
  query jobCandidates($jobIds: [ID!], $first: Int) {
    jobCandidates(jobs: $jobIds, first: $first) {
      data {
        ...JobCandidate
      }
    }
  }
`)
